import { PureComponent } from 'react';
import { View, ScrollView, TouchableOpacity, Image } from 'react-native';
import { Label, DocumentTitle, LabelledView, PickerInput, Link, Text, Loading } from '@symbolic/rn-lib';
import { api } from '@symbolic/lib';
import { connect } from '@symbolic/redux';
import { resourceActions } from '~/redux';
import { accentColorForOrg } from '~/helpers/org-helper';
import _ from 'lodash';

import K from '~/k';
import AdminMenu from '~/components/admin-menu';
import SecondaryHeader from '~/components/secondary-header';

import createIconWhite from '~/assets/create-icon-white.png';

class MechanismSpacingRuleRow extends PureComponent {
  render() {
    var {mechanismSpacingRule, productsById, productOptionsById, productCategoriesById} = this.props;

    var textCellStyle = {paddingHorizontal: K.spacing};

    var getProductsCellText = () => {
      if (_.isEmpty(mechanismSpacingRule.productIds)) return '-';
      else {
        var sortedProductIds = _.sortBy(mechanismSpacingRule.productIds);
        return _.map(sortedProductIds, productId => _.find(productsById, {id: productId}).title).join('/');
      }
    };

    var getBackBoxCellText = () => {
      if (mechanismSpacingRule.backBoxId) {
        var productOption = _.find(productOptionsById, {id: mechanismSpacingRule.backBoxId});

        return `${_.get(productOption, 'title')}\n(ID: ${_.get(productOption, 'id')})`;
      }
      else if (mechanismSpacingRule.backBoxType) {
        return mechanismSpacingRule.backBoxType;
      }
      else {
        return '-';
      }
    };

    return (
      <View
        dataSet={{'hover-background-double-gray': 1}}
        style={{flexDirection: 'row', alignItems: 'center', minHeight: 30, borderRadius: K.borderRadius, backgroundColor: K.colors.gray, marginBottom: K.margin, marginHorizontal: K.spacing}}
      >
        <Link to={`/admin/mechanism-spacing-rules/${mechanismSpacingRule.id}`} style={{paddingLeft: K.spacing, flexDirection: 'row', flex: 1, height: '100%', alignItems: 'center'}}>
          <Text style={{width: 50, opacity: 0.5, ...textCellStyle}}>{mechanismSpacingRule.id}</Text>
          <Text style={{width: 250, opacity: 0.5, ...textCellStyle}}>{mechanismSpacingRule.title}</Text>
          <Text style={{width: 125, opacity: 0.5, ...textCellStyle}}>
            {_.get(_.find(productCategoriesById, {id: mechanismSpacingRule.productCategoryId}), 'title')}
          </Text>
          <Text style={{width: 150, ...textCellStyle}}>{getProductsCellText()}</Text>
          <Text style={{width: 150, ...textCellStyle}}>{getBackBoxCellText()}</Text>
          <Text style={{width: 75, textAlign: 'center', ...textCellStyle}}>{mechanismSpacingRule.axis}</Text>
          <Text style={{width: 125, textAlign: 'right', ...textCellStyle}}>{mechanismSpacingRule.width || '-'}</Text>
          <Text style={{width: 125, textAlign: 'right', ...textCellStyle}}>{mechanismSpacingRule.height || '-'}</Text>
          <Text style={{width: 100, textAlign: 'right', ...textCellStyle}}>{mechanismSpacingRule.columns || '-'}</Text>
          <Text style={{width: 100, textAlign: 'right', ...textCellStyle}}>{mechanismSpacingRule.rows || '-'}</Text>
          <Text style={{width: 150, textAlign: 'right', ...textCellStyle}}>{mechanismSpacingRule.spacing}</Text>
        </Link>
      </View>
    );
  }
}

class AdminMechanismSpacingRulesPage extends PureComponent {
  state = {
    isLoading: true
  };

  async componentDidMount() {
    var mechanismSpacingRules = await api.get('mechanismSpacingRules', {where: {orgId: this.props.session.activeOrg.id}});
    var products = await api.get('products', {where: {orgId: this.props.session.activeOrg.id}});
    var productOptions = await api.get('productOptions', {where: {orgId: this.props.session.activeOrg.id}});
    var productCategories = await api.get('productCategories', {where: {orgId: this.props.session.activeOrg.id}});

    await this.props.trackMechanismSpacingRules({mechanismSpacingRules});
    await this.props.trackProducts({products});
    await this.props.trackProductOptions({productOptions});
    this.props.trackProductCategories({productCategories});

    setTimeout(() => this.setState({isLoading: false}));
  }

  createMechanismSpacingRule = async () => {
    var rule = await api.create('mechanismSpacingRule', {
      orgId: this.props.session.activeOrg.id,
      title: 'Untitled Mechanism Spacing Rule',
      productCategoryId: 1, // Default to Keypads
      axis: 'x',
      spacing: 0
    });

    this.props.trackMechanismSpacingRules({mechanismSpacingRules: [rule]});

    // Navigate to the new rule
    this.props.history.push(`/admin/mechanism-spacing-rules/${rule.id}`);
  };

  render() {
    var {mechanismSpacingRules, productsById, productOptionsById, productCategoriesById} = this.props;

    // Sort productIds within each rule for consistent ordering
    var sortedMechanismSpacingRules = _.map(mechanismSpacingRules, rule => ({
      ...rule,
      productIds: _.sortBy(rule.productIds || [])
    }));

    return (
      <DocumentTitle title={'Admin: Mechanism Spacing Rules'}>
        <View style={{flex: 1, flexDirection: 'row'}}>
          <AdminMenu activeOrg={this.props.session.activeOrg} />
          <View style={{flex: 1}}>
            <SecondaryHeader title={'Mechanism Spacing Rules'} />
            {this.state.isLoading ? (
              <Loading />
            ) : (
              <>
                <ScrollView horizontal={true} style={{flex: 1}} contentContainerStyle={{minWidth: '100%'}}>
                  <ScrollView style={{flex: 1}} contentContainerStyle={{paddingTop: K.spacing, paddingBottom: K.spacing * 4}}>
                    <View style={{paddingLeft: K.spacing * 2, flexDirection: 'row', marginRight: K.spacing}}>
                      {_.map([
                        {title: 'ID', style: {width: 50}},
                        {title: 'Title', style: {width: 250}},
                        {title: 'Category', style: {width: 125}},
                        {title: 'Products', style: {width: 150}},
                        {title: 'Back Box', style: {width: 150}},
                        {title: 'Axis', style: {width: 75, textAlign: 'center'}},
                        {title: 'Width (mm)', style: {width: 125, textAlign: 'right'}},
                        {title: 'Height (mm)', style: {width: 125, textAlign: 'right'}},
                        {title: 'Columns', style: {width: 100, textAlign: 'right'}},
                        {title: 'Rows', style: {width: 100, textAlign: 'right'}},
                        {title: 'Spacing (mm)', style: {width: 150, textAlign: 'right'}},
                      ], ({title, style}) => (
                        <View key={title} style={{...style, padding: K.spacing}}>
                          <Label>{title}</Label>
                        </View>
                      ))}
                    </View>
                    <View style={{minWidth: '100%'}}>
                      {_.map(_.sortBy(sortedMechanismSpacingRules, ['productIds', 'width', 'height', 'columns', 'rows', 'spacing']), (mechanismSpacingRule) => (
                        <MechanismSpacingRuleRow
                          key={mechanismSpacingRule.id}
                          {...{mechanismSpacingRule, productsById, productOptionsById, productCategoriesById}}
                        />
                      ))}
                    </View>
                  </ScrollView>
                </ScrollView>
                <TouchableOpacity
                  onPress={() => this.createMechanismSpacingRule()}
                  style={{position: 'fixed', bottom: K.spacing * 2, left: K.spacing * 2, backgroundColor: accentColorForOrg({org: this.props.session.activeOrg}), width: 70, height: 70, borderRadius: 70, alignItems: 'center', justifyContent: 'center'}}
                >
                  <Image source={createIconWhite} style={{width: K.calc(35), height: K.calc(35)}}/>
                </TouchableOpacity>
              </>
            )}
          </View>
        </View>
      </DocumentTitle>
    );
  }
}

export default connect({
  mapState: (state) => ({
    mechanismSpacingRules: _.values(_.get(state, 'resources.mechanismSpacingRules.byId', {})),
    productsById: state.resources.products.byId,
    productOptionsById: state.resources.productOptions.byId,
    productCategoriesById: state.resources.productCategories.byId,
  }),
  mapDispatch: {
    ..._.pick(resourceActions.mechanismSpacingRules, ['trackMechanismSpacingRules']),
    ..._.pick(resourceActions.products, ['trackProducts']),
    ..._.pick(resourceActions.productOptions, ['trackProductOptions']),
    ..._.pick(resourceActions.productCategories, ['trackProductCategories']),
  }
})(AdminMechanismSpacingRulesPage);
